import * as fromDatatype from '../datatype-library';
import {bl_cms_theme_instance_hdr_RowClass} from './bl_cms_theme_instance_hdr.model';

export interface bl_cms_topic_subscription_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  topic_hdr_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  contact_hdr_guid: fromDatatype.GuidDataFieldInterface;
  member_hdr_guid: fromDatatype.GuidDataFieldInterface;
  login_subject_guid: fromDatatype.GuidDataFieldInterface;
  url: fromDatatype.VarcharDatatypeInterface;
  auth_header_name: fromDatatype.VarcharDatatypeInterface;
  auth_header_value: fromDatatype.VarcharDatatypeInterface;
  notification_contact_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  device_token: fromDatatype.VarcharDatatypeInterface;
}

export class bl_cms_topic_subscription_hdr_RowClass implements bl_cms_topic_subscription_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  topic_hdr_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  contact_hdr_guid: fromDatatype.GuidDataFieldInterface;
  member_hdr_guid: fromDatatype.GuidDataFieldInterface;
  login_subject_guid: fromDatatype.GuidDataFieldInterface;
  url: fromDatatype.VarcharDatatypeInterface;
  auth_header_name: fromDatatype.VarcharDatatypeInterface;
  auth_header_value: fromDatatype.VarcharDatatypeInterface;
  notification_contact_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  device_token: fromDatatype.VarcharDatatypeInterface;
}
